// The four physical zones members scan into — Reception and Cross Fit only have
// an "in" scanner, so their sessions never carry a check-out/duration; Cardio and
// Strength have both. `key` doubles as the exact `floor` query-param value the
// /attendance API expects.
export const ATTENDANCE_FLOORS = [
  { key: 'all',       label: 'All Floors', hasCheckOut: true },
  { key: 'Reception', label: 'Reception',  hasCheckOut: false },
  { key: 'Cardio',    label: 'Cardio',      hasCheckOut: true },
  { key: 'Strength',  label: 'Strength',    hasCheckOut: true },
  { key: 'Cross Fit', label: 'Cross Fit',   hasCheckOut: false },
];
